import React from 'react';
import App from '../App';
import { Provider } from 'react-redux';
import store from '../redux/store';

const RootComponent: React.FC = () => {
  return (
    <Provider store={store}>
      <App />
    </Provider>
  );
};

export default RootComponent;
